import Helper from "../d3-common"

export default function getDimensions(elementId) {
    const dim = Helper.getMaxDimensions(elementId)
    const vizWitdh = dim.w
    const vizHeigth = dim.h
    const vizRadius = dim.max

    const dimensions = {
        width: vizWitdh,
        height: vizHeigth,
        radius: vizRadius / 2,
        margin: {
            top: 30,
            right: 20,
            bottom: 30,
            left: 20
        }
    }
    dimensions.boundedWidth =
        dimensions.radius - dimensions.margin.left - dimensions.margin.right
    dimensions.boundedHeight =
        dimensions.radius - dimensions.margin.top - dimensions.margin.bottom
    dimensions.boundedRadius =
        dimensions.radius -
        (dimensions.margin.left + dimensions.margin.right) / 2

    return dimensions
}
       